import React from 'react';
import { motion } from 'framer-motion';
import { about, skills } from '../content/data';

const AboutSection = () => {
  return (
    <section id="about" className="section-padding">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-h1 gradient-text mb-3">About Me</h2>
          <p className="text-muted text-body-lg max-w-2xl mx-auto">
            {about.headline}. {about.positioning}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="card p-6"
          >
            <h3 className="text-h3 text-accent-blue mb-4">What I'm Looking For</h3>
            <ul className="space-y-3">
              {about.bullets.map((bullet, i) => (
                <li key={i} className="flex items-start gap-3 text-muted">
                  <span className="text-accent-cyan mt-1">→</span>
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="card p-6"
          >
            <h3 className="text-h3 text-accent-purple mb-4">Background</h3>
            <p className="text-muted mb-4">
              Originally from Hagerstown, Maryland. Double majoring in Computer Science (BS) 
              and Mathematics (BA) at Georgetown University.
            </p>
            <p className="text-muted">
              Interested in the intersection of technology and society, especially how 
              software shapes political and social spaces.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h3 className="text-h2 text-center gradient-text mb-8">Tools & Skills</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {skills.map((category, i) => (
              <motion.div
                key={category.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                viewport={{ once: true }}
                className="card p-5"
              >
                <h4 className="text-h3 text-white mb-4">{category.title}</h4>
                <div className="flex flex-wrap gap-2">
                  {category.items.map((skill) => (
                    <span
                      key={skill}
                      className="chip hover:chip-active cursor-default transition-colors"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
